import React from "react";
import {
  Upload,
  Calendar,
  FileText,
  Users,
  ArrowBigLeft,
  ArrowRight,
} from "lucide-react";
import { Link } from "react-router-dom";
import formato from "../docs/formato.docx";

export default function EnvioTrabajos() {
  return (
    <div className="max-w-5xl mx-auto px-6 py-10 space-y-10 mt-16">
      {/* Header */}
      <div className="text-center space-y-3">
        <h1 className="text-4xl font-bold text-[#004270]">Envío de trabajos</h1>
        <p className="text-lg text-gray-600">
          Envía tu trabajo hasta el{" "}
          <span className="font-semibold">30 de septiembre de 2026</span>
        </p>

        <a
          href="https://cmt3.research.microsoft.com/COLAPLAMED2026"
          target="_blank"
          className="inline-flex items-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-xl shadow hover:bg-blue-700 transition"
        >
          <Upload size={18} />
          Enviar artículo
        </a>
      </div>

      {/* Modalidad */}
      <section className="bg-white rounded-2xl shadow p-6 space-y-4">
        <div className="flex items-center gap-2">
          <Users className="text-blue-600" />
          <h2 className="text-2xl font-semibold">Modalidad de participación</h2>
        </div>

        <p className="text-gray-700">
          Puedes participar como <b>asistente</b> o mediante la{" "}
          <b>presentación de un trabajo</b> sobre plantas medicinales en las
          áreas temáticas del congreso.
        </p>

        <ul className="list-disc pl-6 text-gray-700 space-y-1">
          <li>
            <p className="text-gray-700">
              Presentación <b>oral</b>
            </p>
          </li>
          <li>
            <p className="text-gray-700">
              <b>Póster</b> (afiche o cartel)
            </p>
          </li>
        </ul>

        <p className="text-gray-700">
          Los trabajos de <b>grado en ejecución</b> serán en formato póster. Los
          trabajos terminados o de posgrado podrán ser seleccionados para
          presentación oral.
        </p>
      </section>

      {/* Instrucciones */}
      <section className="bg-white rounded-2xl shadow p-6 space-y-4">
        <div className="flex items-center gap-2">
          <FileText className="text-blue-600" />
          <h2 className="text-2xl font-semibold">
            Instrucciones para resúmenes
          </h2>
        </div>
        <ul className="list-decimal pl-6 text-gray-700 space-y-2">
          <li>
            {" "}
            <p className="text-gray-700">
              Idioma: español, inglés o portugués.
            </p>
          </li>
          <li>
            {" "}
            <p className="text-gray-700">
              Formato: una página tamaño carta, márgenes 2.5 cm (vertical) y 3
              cm (horizontal), Word, Arial 10, interlineado simple.
            </p>
          </li>
          <li>
            {" "}
            <p className="text-gray-700">Título máximo de 20 palabras.</p>
          </li>
          <li>
            <p className="text-gray-700">
              {" "}
              Autores y afiliación centrados + correo del autor de
              correspondencia.
            </p>
          </li>
          <li>
            <p className="text-gray-700">Máximo 300 palabras.</p>
          </li>
          <li>
            {" "}
            <p className="text-gray-700">
              Debe incluir: introducción, metodología, resultados, conclusión y
              palabras clave.
            </p>
          </li>
          <li>
            {" "}
            <p className="text-gray-700">
              Debe corresponder a un área temática del congreso.
            </p>
          </li>
          <li>
            {" "}
            <p className="text-gray-700">Evaluación por comité científico.</p>
          </li>
          <li>
            {" "}
            <p className="text-gray-700">Modalidades:</p>
            <ul className="list-disc pl-6 mt-1">
              <li>
                {" "}
                <p className="text-gray-700">Oral (10 minutos)</p>
              </li>
              <li>
                {" "}
                <p className="text-gray-700">Póster (110 cm x 90 cm)</p>
              </li>
            </ul>
          </li>
        </ul>
        <a
          href={formato}
          download
          className="group inline-flex items-center gap-3 bg-blue-400 text-white px-6 py-3 rounded-xl font-semibold shadow-md hover:bg-blue-700 transition-all duration-300"
        >
          <span>Descargar formato del resumen</span>
          <ArrowRight className="transition-transform duration-300 group-hover:translate-x-1" />
        </a>{" "}
      </section>

      {/* Fechas */}
      <section className="bg-white rounded-2xl shadow p-6 space-y-6">
        <div className="flex items-center gap-2">
          <Calendar className="text-blue-600" />
          <h2 className="text-2xl font-semibold">Fechas límite</h2>
        </div>

        <div className="grid md:grid-cols-3 gap-4">
          <div className="border rounded-xl p-4 text-center">
            <h3 className="font-semibold text-lg text-[#004270]">1er envío</h3>
            <p className="text-gray-600">Hasta el 15 de junio de 2026</p>
            <span className="text-sm text-blue-600">Recomendado para oral</span>
          </div>

          <div className="border rounded-xl p-4 text-center">
            <h3 className="font-semibold text-lg text-[#004270]">2do envío</h3>
            <p className="text-gray-600">Hasta el 15 de agosto de 2026</p>
          </div>

          <div className="border rounded-xl p-4 text-center">
            <h3 className="font-semibold text-lg text-[#004270] ">3er envío</h3>
            <p className="text-gray-600">Hasta el 30 de septiembre de 2026</p>
          </div>
        </div>

        <p className="text-gray-600">
          Cada trabajo aceptado será presentado en el congreso previa
          inscripción y pago.
        </p>
      </section>

      {/* Botón final */}
      <div className="text-center">
        <a
          href="https://cmt3.research.microsoft.com/COLAPLAMED2026"
          target="_blank"
          className="inline-flex items-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-xl shadow hover:bg-blue-700 transition"
        >
          <Upload size={18} />
          Enviar artículo
        </a>
      </div>

      {/* Botón final */}
      <div className="text-center">
        <Link
          to={{ pathname: "/", hash: "#inscripcioncongreso" }}
          className="inline-flex items-center gap-2 bg-[#febe10] text-white px-6 py-3 rounded-xl shadow hover:bg-[#004270] transition"
        >
          Inscríbete ahora
          <ArrowRight></ArrowRight>
        </Link>
      </div>
    </div>
  );
}
